import React from 'react';
import {
  Container,
} from 'reactstrap';
import ProjectsWithTasks from '../../Components/TLComponents/ProjectsWithTasks';

const TeamLeadDashboard: React.FC = () => {

  return (
    <Container className="py-4" fluid>
      
      <ProjectsWithTasks />
    </Container>
  );
};

export default TeamLeadDashboard;
